<template>
  <div class="box">

    <top-nav nStyle="white">
    </top-nav>
    <div class="content-box">
      <banner ref="banner"></banner>
      <div>
        <classify ref="classify" ></classify>
      </div>
      <div>
        <label-course v-if="!config.freeCourse" id="mfkc" type="2" size="4" name="免费课程" labelTitle="FREE" labelTitleColor1="#04A1FF" labelTitleColor2="#56C1FF"></label-course>
        <label-course id="rmkc" type="4" name="热门课程" labelTitle="HOT" labelTitleColor1="#FF4F4F" labelTitleColor2="#FF9D9D"></label-course>
        <label-course id="jxkc" type="1" name="精选课程" labelTitle="SIFT" labelTitleColor1="#FF4F4F" labelTitleColor2="#FF9D9D"></label-course>
        <label-course id="tykc" type="3" name="通用课程"></label-course>
      </div>
    </div>
    <right-nav></right-nav>
    <bottom style="margin-top: 150px"></bottom>
  </div>
</template>

<script>
import topNav from "@/components/mall/topNav"
import bottom from "@/components/mall/web/bottom"

import banner from "@/pages/webMall/index/banner.vue"
import classify from "@/pages/webMall/index/classify.vue"
import rightNav from "@/pages/webMall/index/rightNav"
import labelCourse from "@/pages/webMall/index/labelCourse"


import mallApi from "@/api/mall/mall";


import config from '@/config/config.js'

export default {
  name: "index",
  components: {topNav, banner, rightNav, labelCourse, bottom,classify},
  data() {
    return {
      config: config,
      bannerList: []
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    init() {
      let p = {
        trainingName: '',
        labelType: 0,
        priceOrderType: 1,
        industryTypeName: '',
        current: 1,
        size: 12
      }
      mallApi.index(p).then(res => {
        this.$refs.banner.init(res.data.advertList);
      })
    }
  },
  mounted() {
    this.init();
  }
}
</script>

<style scoped>

  .box {
    background-color: #f5f7fa;
    height: 100%;
    overflow-y: scroll;
  }

  .content-box {
    width:  1150px;
    margin-right: auto;
    margin-left: auto;
    margin-top: 19px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/webMall/index/index.vue